import { isLaunchedBridgeStatus, type LaunchedBridgeStatus } from '../utils/bridge/bridgeCause';
import { companyScopedKey } from './bridgeCompany';

/**
 * What Acomba reported about the bridge when it opened this window. Only consulted when the bridge
 * cannot be reached at all — a live `/health` is always the better answer.
 * Kept per société, being a per-launch snapshot rather than a standing property of the poste.
 */

const BRIDGE_LAUNCH_STATUS_KEY = 'bridge-launch-status';

export function setBridgeLaunchStatus(status: string | null | undefined): void {
    if (!isLaunchedBridgeStatus(status)) return;

    try {
        localStorage.setItem(companyScopedKey(BRIDGE_LAUNCH_STATUS_KEY), status);
    } catch {
        // Private mode or quota: the view falls back to its unexplained-failure message.
    }
}

/** Re-checked on read, so an edited value cannot reach the message table as an unknown cause. */
export function getBridgeLaunchStatus(): LaunchedBridgeStatus | null {
    try {
        const scoped = localStorage.getItem(companyScopedKey(BRIDGE_LAUNCH_STATUS_KEY));
        if (isLaunchedBridgeStatus(scoped)) return scoped;

        const legacy = localStorage.getItem(BRIDGE_LAUNCH_STATUS_KEY);
        return isLaunchedBridgeStatus(legacy) ? legacy : null;
    } catch {
        return null;
    }
}

export function clearBridgeLaunchStatus(): void {
    try {
        localStorage.removeItem(companyScopedKey(BRIDGE_LAUNCH_STATUS_KEY));
        localStorage.removeItem(BRIDGE_LAUNCH_STATUS_KEY);
    } catch {
        // Storage unavailable; nothing to remove.
    }
}
